import { useTankContext } from '../../../context/ProviderPage/Tanque';
import { toBase64 } from '../../../utils/toBase64';
import { returnCheckType } from '../../../utils/returnCheckType';
import { IModal, ModalInfoTemplete } from '../ModalInfoTemplete';
import {
  ColumnItens,
  ContainerCheck,
  ContainerItemModal,
  RowItens,
} from '../ModalInfoTemplete/styles';

export const InfoTank = ({
  closeModal,
  isOpen,
  titleModal,
  option,
}: IModal) => {
  const { selectedTank } = useTankContext();
  const {
    DFATIVO,
    DFCOLETASELETIVA,
    DFDESCTANQUE,
    DFIDTANQUE,
    DFNOMELINHA,
    DFIMAGEMTANQUE,
  } = selectedTank;

  return (
    <ModalInfoTemplete
      option={option}
      titleModal={titleModal}
      closeModal={closeModal}
      isOpen={isOpen}
    >
      <ColumnItens>
        <RowItens>
          <ContainerItemModal>
            <label>Código</label>
            <div>
              <span>{DFIDTANQUE || 'Não informado'}</span>
            </div>
          </ContainerItemModal>
          <ContainerItemModal>
            <label>Descrição</label>
            <div>
              <span>{DFDESCTANQUE || 'Não informado'}</span>
            </div>
          </ContainerItemModal>
        </RowItens>
        <RowItens>
          <ContainerItemModal>
            <label>Linha</label>
            <div>
              <span>{DFNOMELINHA || 'Não informado'}</span>
            </div>
          </ContainerItemModal>
          <ContainerCheck>
            <div>
              <label>Ativo</label>
              <img src={returnCheckType(DFATIVO!)} />
            </div>
            <div>
              <label>Coleta Seletiva</label>
              <img src={returnCheckType(DFCOLETASELETIVA!)} />
            </div>
          </ContainerCheck>
        </RowItens>

        {DFIMAGEMTANQUE && (
          <RowItens>
            <ContainerItemModal>
              <label>Foto do Tanque</label>
              <div style={{ marginTop: '5px' }}>
                <img
                  src={toBase64(DFIMAGEMTANQUE)}
                  alt="Foto do tanque"
                  style={{
                    width: '100%',
                    maxHeight: '300px',
                    objectFit: 'contain',
                    borderRadius: '8px',
                    border: '1px solid #eee',
                  }}
                />
              </div>
            </ContainerItemModal>
          </RowItens>
        )}
      </ColumnItens>
    </ModalInfoTemplete>
  );
};
